import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CompletedTransactions from './Completed/CompletedTransactions';
import FutureTransactions from './Future/FutureTransactions';
import GrossEarnings from './GrossEarnings/GrossEarnings';
import TotalAmount from './TotalAmount';
import Loader from '../Loader';
import ModalFilter from './ModalFilter/ModalFilter';
import CustomPagination from '../CustomPagination';

import { onChangeListing } from '../../actions/Listing/onChangeListing';
import { payoutChangeListing } from '../../actions/Payout/payoutChangeListing';
import { openTransactionModal } from '../../actions/modalActions';

import messages from '../../locale/messages';
import history from '../../core/history';
import { debounce } from '../../helpers/debounce';

import filterIcon from '/public/SiteIcons/reservationFilter.svg';
import { FilterCSVExportIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../helpers/showToaster';

import bt from '../../components/commonStyle.css';
import s from './Transaction.css';

const Transaction = ({ data, mode }) => {

  const [transactionData, setTransactionData] = useState({
    currentPage: 1,
    payoutId: null,
    listId: null,
    searchKey: ''
  });
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [isDemoRestrict, setRestrict] = useState('false');

  const { loading, getTransactionHistory, refetch } = data;
  const { currentPage, payoutId, listId, searchKey } = transactionData;

  const { toCurrency, siteName, profileId } = useSelector((state) => ({
    toCurrency: state.currency.to || state.currency.base,
    siteName: state.siteSettings && state.siteSettings.data.siteName,
    profileId: state?.account?.data?.profileId
  }));


  useEffect(() => {
    async function fetchData() {
      const isRestrict = await dispatch(userRestriction({ restrictType: 'profile', restrictValue: profileId }));
      setRestrict(isRestrict);
    }
    fetchData();
  }, []);

  const handleSearchChange = debounce((searchKey) => {
    let variables = { searchKey, currentPage: 1 }
    setTransactionData(prevObject => ({ ...prevObject, ...variables }));
    refetch(variables)
  }, 250)

  const handleChange = ({ mode, payoutId, listId }) => {
    let variables = {
      mode,
      currentPage: 1,
      payoutId: Number(payoutId),
      listId: Number(listId)
    };
    setTransactionData(prevObject => ({ ...prevObject, currentPage: 1, payoutId: Number(payoutId), listId: Number(listId) }));
    refetch(variables);
  }

  const restrictExport = () => {
    showToaster({ messageId: 'disableDemo', toasterType: 'warning' })
  };

  const handleChangeFirst = (mode) => {
    setTransactionData({
      currentPage: 1,
      payoutId: null,
      listId: null,
      searchKey: ''
    });
    history.push(`/user/transaction/${mode}`);
    dispatch(onChangeListing({ listId: null, payoutId: null }));
    dispatch(payoutChangeListing(null));
  }

  const paginationData = (currentPage) => {
    let variables = { currentPage };
    setTransactionData(prevObject => ({ ...prevObject, currentPage }));
    refetch(variables)
  }

  const page1Active = mode === 'completed' ? s.active : '';
  const page2Active = mode === 'future' ? s.active : '';
  const page3Active = mode === 'grossEarnings' ? s.active : '';

  const showPayouts = mode === 'completed' || mode === 'grossEarnings';
  const showTotal = mode === 'completed' || mode === 'future';

  let userId;
  if (!loading && getTransactionHistory?.reservationData) {
    if (getTransactionHistory.reservationData.length > 0) {
      userId = getTransactionHistory.reservationData[0].hostId;
    }
  }

  return (
    <div>
      <div className={cx('commonListingBg', 'noMarginBottom', 'transactionList')}>
        <ul className={cx(s.transactionTabList)}>
          <li className={cx(page1Active, s.mobileWidth)}>
            <a className={cx(s.transactionTabItem)} onClick={() => handleChangeFirst('completed')}>
              <FormattedMessage {...messages.completedTransactions} />
            </a>
          </li>
          <li className={cx(page2Active, s.mobileWidth)}>
            <a className={cx(s.transactionTabItem)} onClick={() => handleChangeFirst('future')}>
              <FormattedMessage {...messages.futureTransactions} />
            </a>
          </li>
          <li className={cx(page3Active, s.mobileWidth)}>
            <a className={cx(s.transactionTabItem)} onClick={() => handleChangeFirst('grossEarnings')}>
              <FormattedMessage {...messages.grossEarnings} />
            </a>
          </li>
        </ul>
        {!loading && showTotal && getTransactionHistory?.totalCount > 0 && getTransactionHistory?.totalData && (
          <TotalAmount mode={mode} data={getTransactionHistory.totalData} />
        )}
        {!loading && getTransactionHistory?.totalCount > 0 && (
          <div className={s.listFlex}>
            <div className={s.searchWidth}>
              <FormGroup className={s.noMargin}>
                <FormControl
                  type="text"
                  placeholder={formatMessage(messages.SearchTransactions)}
                  className={cx(s.formControlInput, s.transactionSearchInput, 'prefixIconInputRtl')}
                  onChange={(e) => handleSearchChange(e.target.value)}
                />
              </FormGroup>
            </div>
            <div className={s.filterBtnSection}>
              {getTransactionHistory?.count > 0 &&
                (isDemoRestrict ? <a
                  href="#" onClick={() => restrictExport()}
                  className={s.csvLink}
                >
                  <FilterCSVExportIcon className={cx(s.filterIcon, 'filterIconRTL')} />
                  <FormattedMessage {...messages.exportCSV} />
                </a> :
                  <a
                    href={`/export-transaction?siteName=${siteName}&type=${mode}&toCurrency=${toCurrency}&listId=${listId || ''}&payoutId=${payoutId || ''}&searchKey=${searchKey || ''}`}
                    className={s.csvLink}
                  >
                    <FilterCSVExportIcon className={cx(s.filterIcon, 'filterIconRTL')} />
                    <FormattedMessage {...messages.exportCSV} />
                  </a>)
              }
              <Button
                className={cx({ [s.linkCssActive]: payoutId || listId }, s.linkCss, s.mobileSearchWidth, 'filterBtnRTL', 'svgImg')}
                onClick={() => dispatch(openTransactionModal())}
              >
                <img src={filterIcon} />
                <FormattedMessage {...messages.filters} />
              </Button>
            </div>
          </div>
        )}

        <ModalFilter handleResults={handleChange} showPayouts={showPayouts} mode={mode} />

        {loading && <Loader type={"text"} />}
        {!loading && mode === 'completed' && getTransactionHistory?.reservationData && (
          <CompletedTransactions data={getTransactionHistory.reservationData} totalCount={getTransactionHistory.totalCount} />
        )}

        {!loading && mode === 'future' && getTransactionHistory?.reservationData && (
          <FutureTransactions data={getTransactionHistory.reservationData} totalCount={getTransactionHistory.totalCount} />
        )}

        {!loading && mode === 'grossEarnings' && getTransactionHistory?.reservationData && (
          <GrossEarnings data={getTransactionHistory.reservationData} totalCount={getTransactionHistory.totalCount} />
        )}
      </div>

      {getTransactionHistory?.count !== null && getTransactionHistory?.count > 0 && (
        <div>
          <CustomPagination
            total={getTransactionHistory.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={5}
            change={paginationData}
            componentReference={mode}
            paginationLabel={formatMessage(messages.transactions)}
          />
        </div>
      )}
    </div>
  );
};

Transaction.propTypes = {
  formatMessage: PropTypes.any,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    refetch: PropTypes.any.isRequired,
    getTransactionHistory: PropTypes.shape({
      count: PropTypes.number.isRequired,
      reservationData: PropTypes.arrayOf(PropTypes.shape({
        hostId: PropTypes.string.isRequired,
        checkIn: PropTypes.string.isRequired,
        checkOut: PropTypes.string.isRequired,
        confirmationCode: PropTypes.number.isRequired,
        listData: PropTypes.shape({
          title: PropTypes.string.isRequired
        }),
        guestData: PropTypes.shape({
          firstName: PropTypes.string.isRequired
        }),
        hostTransaction: PropTypes.shape({
          payoutId: PropTypes.number,
          payEmail: PropTypes.string,
          amount: PropTypes.number,
          currency: PropTypes.string,
          createdAt: PropTypes.string
        })
      }))
    }),
  }).isRequired
};

export default (withStyles(bt, s)(Transaction));